import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorEjecutorService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorEjecutorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorEjecutorService_Factory() { return new EventMantenedorEjecutorService(); }, token: EventMantenedorEjecutorService, providedIn: "root" });
